<section class="w-full">
    <div class="flex flex-col items-center justify-center">
        <div class="w-full flex justify-center items-center mb-10">
            <div class="flex flex-col justify-center items-center mt-10">
                @if (view.site && view.site.profile && view.site.profile.heading) {
                @switch (view.site.profile.heading.position) {
                @case (1) {
                <app-heading_section-type01
                    [options]="{heading:'Testimonial',title:'Trusted Reviews by our Customers',image:'', description:'',swooshAlign: {'margin':''} }"></app-heading_section-type01>
                }
                @case (2) {
                <app-heading_section-type01
                    [options]="{heading:'Testimonial',title:'Trusted Reviews by our Customers',image:'assets/xltravel/swoosh-01.svg', description:''}"></app-heading_section-type01>
                }
                @case (4) {
                <app-heading_section-type01
                    [options]="{ heading:'Testimonials',title:'Trusted Reviews by our Customers',image:'', description:'' }"></app-heading_section-type01>
                }

                }
                }
            </div>
        </div>

        <div class="w-[100%] md:w-[85%] lg:w-[90%] xl:w-[90%] m-auto ">
            <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig"
                (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
                (beforeChange)="beforeChange($event)">
                @for(testimonial of view.testimonials; track testimonial) {
                <fuse-card ngxSlickItem
                    class="relative flex flex-col justify-start m-2 items-center p-6 bg-white dark:bg-slate-500 hover:border-primary-500 transition ease-out duration-500">
                    <div class="flex w-full items-center justify-between rounded-lg">
                        <div class="flex">
                            <!-- <img src="assets/images/avatars/male-01.jpg" class="rounded-lg w-22 h-auto" alt=""> -->

                            <div class="flex flex-col w-60">
                                <h4 class="text-2xl font-primary font-semibold">{{testimonial.name}}</h4>
                                <!-- <h4 class="text-sm text-gray-400 font-semibold">Singapore</h4> -->
                                @if(testimonial.metaDataParsed?.grading == 1) {
                                <div class="flex">
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                </div>
                                }
                                @if(testimonial.metaDataParsed?.grading == 2) {
                                <div class="flex">
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                </div>
                                }
                                @if(testimonial.metaDataParsed?.grading == 3) {
                                <div class="flex">
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                </div>
                                }
                                @if(testimonial.metaDataParsed?.grading == 4) {
                                <div class="flex">
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                </div>
                                }
                                @if(testimonial.metaDataParsed?.grading == 5) {
                                <div class="flex mb-2">
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                    <mat-icon class="text-primary-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                                </div>
                                }
                            </div>
                        </div>
                        <div>
                            <mat-icon class="icon-size-10 lg:icon-size-12 text-primary-500 rounded-full"
                                [svgIcon]="'mat_solid:format_quote'"></mat-icon>
                        </div>
                    </div>
                    <div class="flex grow-0 flex-col justify-center items-center">
                        <p class="mb-2 text-md text-gray-600 dark:text-white text-justify"
                            [innerHTML]="testimonial.rawContentShort"></p>
                    </div>
                </fuse-card>
                }
            </ngx-slick-carousel>
        </div>
    </div>
</section>